import { clientHttp } from '@/shared/api/client'
import { CLIENT_API_ENDPOINTS } from '@/shared/lib'

import type { ITerms } from '../../model/terms'

export const getTerms = async ({ type }: { type: string }): Promise<ITerms> => {
  return clientHttp.get(CLIENT_API_ENDPOINTS.TERMS.DETAIL(type))
}
